import { render, staticRenderFns } from "./Test2.vue?vue&type=template&id=c50680ba&scoped=true&lang=pug&"
import script from "./Test2.vue?vue&type=script&lang=js&"
export * from "./Test2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50680ba",
  null
  
)

export default component.exports